import { StreetType } from './api-client/enums'

export const ROUTES = {
  Home: '/',
  Register: '/register',
  Buy: '/buy',
  Sell: '/sell',
  Vehicle: '/vehicle',
  VehicleDetails: '/sell/vehicle-details',
  VehicleLogs: '/sell/vehicle',
  GetVerified: '/get-verified',
  NeedHelp: '/help',
  BuyerFaq: '/buyer-faq',
  SellerFaq: '/seller-faq',
  PurchaseAuction: '/purchase/auction',
  PurchaseBuyNow: '/purchase/buy-now',
  About: '/about-us',
  Contact: '/contact-us',
  SignIn: '/sign-in',
  Support: '/support',
  Search: '/search',
  Account: '/account',
  Terms: '/terms',
  Privacy: '/privacy',
  Blog: '/blog',
  Dealers: '/dealers',
  PreQualify: '/pre-qualify',
  Membership: '/memberships',
  Sort: '/sort',
}

export const ERRORS = {
  GENERAL_SERVER_ERROR: 'Something went wrong. Please try again.',
}

export const zIndex = {
  Negative: -10000,
  Ground: 0,
  Layout: 10000,
  Absolute: 20000,
  Fixed: 30000,
  Modal: 40000,
  zMax: 90000,
}

export const UNITS = {
  KM: 'km',
  MILES: 'mi',
}

export const MAX_AGE_OF_VEHICLE_FOR_LEASE = 6

export const DeviceType = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop',
}

// Role-based access permissions
export const permissions = {
  viewKbbData: 'kbb:view',
  manageCashOffer: 'cashOffer:manage',
  managePreQualify: 'pre-qualify:manage',
}

export const StreetTypeSelectOptions = Object.entries(StreetType).map(([key, value]) => ({
  label: key,
  value,
}))

export const MINIMUM_AGE_LIMIT = 18
